import { LanguageSelectorConfig } from "@/interfaces";
import configRaw from "../../config.json";

export interface LanguageChoice {
  path: string;
  id: string;
}

const config: LanguageSelectorConfig = configRaw as LanguageSelectorConfig;

const localStorageKey = `selectedOption-${config.id}`;

export function retrieveLanguageChoice(): LanguageChoice | null {
  const selectorData = window.localStorage.getItem(localStorageKey);
  if (!selectorData) return null;
  const data: LanguageChoice = JSON.parse(selectorData);
  if (config.id === data.id) return data;
  return null;
}

export function storeLanguageChoice(choice: string) {
  window.localStorage.setItem(
    localStorageKey,
    JSON.stringify({ path: choice, id: config.id } as LanguageChoice)
  );
}
